import { render, staticRenderFns } from "./CardComponent.vue?vue&type=template&id=237f458d&scoped=true"
import script from "./CardComponent.vue?vue&type=script&lang=js"
export * from "./CardComponent.vue?vue&type=script&lang=js"
import style0 from "./CardComponent.vue?vue&type=style&index=0&id=237f458d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237f458d",
  null
  
)

export default component.exports